var map = {
	"./active-check-ico.svg": "283b",
	"./arrow.svg": "315f",
	"./basket.svg": "1c23",
	"./black-arrow-down.svg": "68cb",
	"./check-all-black.svg": "4731",
	"./check-all.svg": "7f92",
	"./checkbox.svg": "1748",
	"./coin.svg": "b745",
	"./delete.svg": "4edd",
	"./diamond.svg": "cead",
	"./down_arrow.svg": "0117",
	"./down_arrow_black.svg": "5faf",
	"./download-white.svg": "039c",
	"./download.svg": "22b4",
	"./duble-arrow.svg": "04cb",
	"./green-check.svg": "3deb",
	"./ico-error.svg": "9bfa",
	"./ico-success.svg": "58d9",
	"./left-arrow.svg": "3457",
	"./location.svg": "c391",
	"./money.svg": "c657",
	"./pdf.svg": "3e10",
	"./pdf1.svg": "aaa8",
	"./pen.svg": "13bc",
	"./play.svg": "09dc",
	"./premium.svg": "889e",
	"./right-arrow.svg": "689d",
	"./save.svg": "107a",
	"./smallArrow.svg": "c5d6",
	"./user-ico.svg": "b543"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f350";